// Indicadores de despacho (épico PO1-3493): rotas /despacho/indicadores/* do
// backend_hub (instância `api`, que leva o embarcador ativo no header
// X-Active-Embarcador-Id). Todas exigem hub.operacao.despacho.visualizar.
// Filtros comuns: { de: 'YYYY-MM-DD', ate: 'YYYY-MM-DD', transportadoras: [] }.
import api from "./api";
import { nomeDoContentDisposition } from "./despachoApi";

export const RESUMO_VAZIO = {
  etiquetas: { emitidas: 0, falhas: 0, canceladas: 0, emProcessamento: 0, taxaFalha: 0 },
  porTransportadora: [],
  motivosFalha: [],
  lotes: { despachados: 0, abertos: 0, fechadosSemDespacho: 0, porOrigem: { manual: 0, horario: 0, volume: 0 } },
  coletas: { solicitadas: 0, falhas: 0, despachadosSemColeta: 0 },
  porDia: [],
};

const lista = (v) => (Array.isArray(v) ? v : []);
const objeto = (v) => (v && typeof v === "object" && !Array.isArray(v) ? v : {});

// Completa o que faltar com zeros/listas vazias: o resumo do dashboard (PO1-3494)
// tem 6 componentes lendo o mesmo objeto e nenhum pode quebrar por chave ausente.
export function normalizarResumo(data) {
  const d = objeto(data);
  const lotes = objeto(d.lotes);
  return {
    etiquetas: { ...RESUMO_VAZIO.etiquetas, ...objeto(d.etiquetas) },
    porTransportadora: lista(d.porTransportadora),
    motivosFalha: lista(d.motivosFalha),
    lotes: { ...RESUMO_VAZIO.lotes, ...lotes, porOrigem: { ...RESUMO_VAZIO.lotes.porOrigem, ...objeto(lotes.porOrigem) } },
    coletas: { ...RESUMO_VAZIO.coletas, ...objeto(d.coletas) },
    porDia: lista(d.porDia),
  };
}

// GET /despacho/indicadores/resumo — já normalizado.
export async function obterResumo(params = {}) {
  const { data } = await api.get("/despacho/indicadores/resumo", { params });
  return normalizarResumo(data);
}

export const ETAPAS_VAZIO = { cards: {}, itens: [], total: 0, pagina: 1, tamanhoPagina: 25, tempos: [] };

// GET /despacho/indicadores/etapas — lista paginada dos envios por etapa.
// params extras: { etapa, busca, pagina, tamanhoPagina }. Os `cards` seguem só
// período e transportadora (não a busca nem a etapa).
export async function listarEtapas(params = {}) {
  const { data } = await api.get("/despacho/indicadores/etapas", { params });
  const d = objeto(data);
  return {
    ...ETAPAS_VAZIO,
    ...d,
    cards: objeto(d.cards),
    itens: lista(d.itens),
    tempos: lista(d.tempos),
    total: Number(d.total) || 0,
  };
}

// GET /despacho/indicadores/etapas.csv — mesmos filtros, sem paginação. Vem como
// blob e vira <a download> na tela (utils/downloadBlob). Devolve { conteudo, nome }.
export async function baixarEtapasCsv(params = {}) {
  const resp = await api.get("/despacho/indicadores/etapas.csv", { params, responseType: "blob" });
  return { conteudo: resp.data, nome: nomeDoContentDisposition(resp.headers, "despacho-etapas.csv") };
}

// Quadro (PO1-3500): as 7 colunas, sempre nesta ordem (mesma dos cards).
export const ETAPAS_QUADRO = ["falha", "emProcessamento", "foraDeLote", "loteAberto", "loteFechado", "coletaFalha", "despachadoSemColeta"];
export const LIMITE_QUADRO_PADRAO = 20;

// Resposta null, coluna faltando ou fora de ordem viram as 7 colunas na ordem
// do fluxo; etapa desconhecida é descartada. `total` nunca fica abaixo do que
// veio em `itens` (é ele que decide o "Mostrando X de N").
export function normalizarQuadro(data) {
  const d = objeto(data);
  const recebidas = lista(d.colunas).reduce((acc, c) => {
    const col = objeto(c);
    if (col.etapa) acc[col.etapa] = col;
    return acc;
  }, {});
  const colunas = ETAPAS_QUADRO.map((etapa) => {
    const col = objeto(recebidas[etapa]);
    const itens = lista(col.itens).filter((i) => i && typeof i === "object");
    return { etapa, total: Math.max(Number(col.total) || 0, itens.length), itens };
  });
  return { periodo: objeto(d.periodo), limite: Number(d.limite) || LIMITE_QUADRO_PADRAO, colunas };
}

// GET /despacho/indicadores/quadro — cartão = pedido (ou NF sem pedido).
// params: { de, ate, transportadoras, busca, limite } (limite: padrão 20, máx. 50).
export async function obterQuadro(params = {}) {
  const { data } = await api.get("/despacho/indicadores/quadro", { params });
  return normalizarQuadro(data);
}
